import React from 'react';
import './CoachReactionChip.css';

const CoachReactionChip = ({ reaction, coachName = 'Coach', outputRef }) => {
  if (!reaction?.emoji) return null;
  const label = reaction.label || reaction.key || 'Reaction';
  return (
    <span
      ref={outputRef}
      className={`coach-reaction-border-chip sentiment-${reaction.sentiment || 'neutral'}`}
      role="img"
      aria-label={`${coachName} reacted: ${label}`}
      title={`${coachName}: ${label}`}
    >
      {reaction.emoji}
    </span>
  );
};

export default CoachReactionChip;
